<template>
  <div
    class="text-sm"
    :class="[
      $style.banner,
      {
        'bg-applicationBanner-background-error': status === 'error',
        'bg-applicationBanner-background-warning': status === 'warning',
        'bg-applicationBanner-background-info': status === 'info',
        'bg-applicationBanner-background-success': status === 'success',
      },
    ]"
  >
    <!-- @slot content of the banner -->
    <slot />
    <!--
      triggered after clicking the 'x' button
      @event close
    -->
    <button v-if="!stubborn" class="absolute right-4 top-3" type="button" @click="$emit('close')">
      <x-icon class="icon-m" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'
import { XIcon } from '../icons'

withDefaults(
  defineProps<{
    status?: 'info' | 'error' | 'warning' | 'success' // style of the banner
    stubborn?: boolean // if "true", hides the close button
  }>(),
  {
    status: 'info',
    stubborn: false,
  },
)

defineComponent({
  name: 'UiBanner',
})
</script>

<style lang="scss" module>
.banner {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 12px;
  text-align: center;
  font-weight: theme('fontWeight.medium');
  color: var(--white);

  a {
    color: var(--white);
    border-bottom: solid 1px var(--white);
  }
}
</style>
